import { render } from "./g-intranet-layout__navbar-item.vue?vue&type=template&id=9c4900e2&ts=true"
import script from "./g-intranet-layout__navbar-item.vue?vue&type=script&lang=tsx"
export * from "./g-intranet-layout__navbar-item.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__